module.exports = __webpack_public_path__ + "media/assets/svg/logos/nosco_logo_full_negative-fd4a5ad56bfde2e10d65f92496ff50a1.svg";